import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { KiwixiService } from '../../../kiwixi/kiwixi.service';
import { ExaminationService } from '../../../service/examination.service';
import { MaterialService } from '../../../service/material.service';
import { SharedAppState } from '../../../store/app.states';
import { LilateCardRecComponent } from '../lilate-card-rec.component';

@Component({
  selector: 'app-lilate-card-cancelled-by-teacher-rec',
  templateUrl: './lilate-card-cancelled-by-teacher-rec.component.html',
  styleUrls: ['./lilate-card-cancelled-by-teacher-rec.component.scss', '../lilate-card-rec.component.scss']
})
export class LilateCardCancelledByTeacherRecComponent extends LilateCardRecComponent {
  @Input() bloc: string;

  constructor(
    _router: Router,
    materialService: MaterialService,
    translateService: TranslateService,
    kiwixiService: KiwixiService,
    examinationService: ExaminationService,
    store: Store<SharedAppState>
  ) {
    super(
      _router,
      materialService,
      translateService,
      kiwixiService,
      examinationService,
      store
    )
  }

}
